import PropTypes from "prop-types"
import React, { Component } from "react"

// This function takes a component...
function AccountSelectHOC(WrappedComponent) {
  return class extends Component {
    static propTypes = {
      format: PropTypes.string.isRequired,
    }

    constructor(props) {
      super(props)
      this.state = {
        activeAccount: null,
      }

      WrappedComponent.prototype.getUrl = this.getUrl // eslint-disable-line
    }

    static getDerivedStateFromProps({ location, format }) {
      const splitForm = format.split("/")
      const platformIndex = splitForm.indexOf("{account}")
      const splitUrl = location.pathname.split("/")
      const accountKey = splitUrl[platformIndex]

      return {
        activeAccount: accountKey,
      }
    }

    getUrl(platform, account) {
      const { format } = this.props
      let url = format || ""
      url = url.replace("{platform}", platform)
      url = url.replace("{account}", account)
      return url
    }

    render() {
      const { activeAccount } = this.state
      return <WrappedComponent activeAccount={activeAccount} {...this.props} />
    }
  }
}

export default AccountSelectHOC
